<template>
  <div
    class="webshop-receipt bg-white rounded py-5 ota-p16"
    :class="{ 'lg:pb-0': isCheckoutType }"
  >
    <div
      class="flex px-7"
      :class="{ 'px-10': isCheckoutType }"
    >
      <span v-text="$t('Loyalty.Webshop.Cart.Value')" />
      <span class="ml-auto" v-text="toEuros(cartTotal)" />
    </div>
    <div
      class="px-5 my-rem"
      :class="{ 'px-rem': !isCheckoutType }"
    >
      <div class="bg-purple-400 rounded-lg text-white flex px-5 py-rem ota-p18 font-body">
        <span v-text="isConfirmationType ? $t('Loyalty.Webshop.Cart.YourRedeemedCredits'): $t('Loyalty.Webshop.Cart.YourCredits')" />
        <span class="ml-auto" v-text="isConfirmationType ? toEuros(cartTotal) : toEuros(credits)" />
      </div>
    </div>
    <div
      class="flex px-7"
      :class="{ 'px-10': isCheckoutType }"
    >
      <span v-text="$t('Loyalty.Webshop.Cart.Subtotal')" />
      <span class="ml-auto" v-html="`<span class='ota-p18 font-bold text-purple-400'>${toEuros(0)}</span>`" />
    </div>
    <div
      class="flex px-7 border-t border-b border-gray-200 py-rem mt-5"
      :class="{ 'px-10': isCheckoutType }"
    >
      <span v-text="$t('Loyalty.Webshop.Cart.ShippingCosts')" />
      <span class="ml-auto" v-text="shippingCosts" />
    </div>
    <div
      class="flex px-7 pt-5"
      :class="{ 'px-10': isCheckoutType }"
    >
      <span v-text="$t('Loyalty.Webshop.Cart.Total')" />
      <span class="ml-auto webshop-receipt-total" v-html="`<span class='montserrat-currency font-extrabold'>${shippingCosts}</span>`" />
    </div>
    <div
      v-if="isCheckoutType || isConfirmationType"
      class="flex px-7 py-5 border border-gray-200 mt-10"
      :class="{ 'px-10 lg:border-l-0 lg:border-r-0 lg:border-b-0 lg:rounded-b': isCheckoutType }"
    >
      <span v-text="$t('Loyalty.Webshop.Cart.PostPaymentCredits')" />
      <span class="ml-auto" v-text="toEuros(credits - cartTotal)" />
    </div>
  </div>
</template>

<script>
import { getEuros } from '@/utils/general'
import { CartTypes } from '@/enums/webshop'

export default {
  name: 'WebshopReceipt',
  props: {
    cartTotal: {
      type: Number,
      default: 0
    },
    country: {
      type: String,
      default: 'nl'
    },
    type: {
      type: String,
      default: CartTypes.Cart,
      validator: value => Object.keys(CartTypes).includes(value)
    },
    credits: {
      type: Number,
      default: 0
    },
    shippingCosts: {
      type: String,
      default: ''
    }
  },
  computed: {
    isCheckoutType () {
      return this.type === CartTypes.Checkout
    },
    isConfirmationType () {
      return this.type === CartTypes.Confirmation
    }
  },
  methods: {
    toEuros (price = '0') {
      return getEuros(this.country, price, true)
    }
  }
}
</script>

<style lang="postcss" scoped>
.webshop-receipt {
  &-total {
    font-size: 2.4rem;
  }
}
</style>
